/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A user who currently holds a user-level access grant on a claim the caller can access. Used to populate the assignee filter. Unlike AssignableUser this may include the caller and users from other companies reached via cross-company shares.
 * @export
 * @interface AssignedUser
 */
export interface AssignedUser {
    /**
     * 
     * @type {number}
     * @memberof AssignedUser
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof AssignedUser
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AssignedUser
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof AssignedUser
     */
    role: string;
}

/**
 * Check if a given object implements the AssignedUser interface.
 */
export function instanceOfAssignedUser(value: object): value is AssignedUser {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    return true;
}

export function AssignedUserFromJSON(json: any): AssignedUser {
    return AssignedUserFromJSONTyped(json, false);
}

export function AssignedUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignedUser {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'email': json['email'],
        'role': json['role'],
    };
}

export function AssignedUserToJSON(json: any): AssignedUser {
    return AssignedUserToJSONTyped(json, false);
}

export function AssignedUserToJSONTyped(value?: AssignedUser | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'email': value['email'],
        'role': value['role'],
    };
}

